import {StepIndex} from "../types/PackageForm";
import {WizardSaveInput} from "../types/WizardSaveInput";


const transportFields = [
  "direction", "arrivalTransport", "arrivalTransportDate", "arrivalTransportTime", "arrivalNumberOfPassengers",
  "arrivalLocationFrom", "arrivalLocationTo", "arrivalTransportReference", "arrivalTransportReferenceNumber",
  "departureTransport", "departureTransportDate", "departureTransportTime", "departureNumberOfPassengers",
  "departureLocationFrom", "departureLocationTo", "departureTransportReference", "departureTransportReferenceNumber",
  "pickUpTime"
]

const personalFields = [
  "name", "surname", "email", "dial", "telephone", "nationality", "documentType", "invoiceNameAndSurname",
  "invoiceAddress", "cardName", "cardNumber", "cardDateMonth", "cardDateYear", "selectedPaymentCardUuid",
  "privacyPolicy", "contractTerms"
]

export const getStepFields = (step: StepIndex): (keyof WizardSaveInput)[] => {
  if (step === 1) {
    return ["selectedRoomId"] as (keyof WizardSaveInput)[];
  } else if (step === 2) {
    return [] as (keyof WizardSaveInput)[];
  } else if (step === 3) {
    return ["guests"] as (keyof WizardSaveInput)[];
  } else if (step === 4) {
    return transportFields as (keyof WizardSaveInput)[];
  } else if (step === 5) {
    return [] as (keyof WizardSaveInput)[];
  } else if (step === 6) {
    return personalFields as (keyof WizardSaveInput)[];
  }
  return [];
};